"use strict";

var _toConsumableArray = require("/codebuild/output/src073659321/src/turo-project/turo-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function hasEqualCharacterData() {
  var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    styles: []
  };
  var right = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    styles: []
  };
  return left != null && right != null && right.entity === left.entity && Array.from(left.styles || []).sort().join('') === Array.from(right.styles || []).sort().join('');
}

function createTextFragments(value) {
  var entityMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var start = [];
  return value.reduce(function (acc, data, index) {
    if (acc.length < 1) {
      return [{
        styles: data.styles,
        entity: data.entity,
        offset: index,
        text: value[index].char
      }];
    } else {
      var lastFragment = acc[acc.length - 1];

      if (hasEqualCharacterData(lastFragment, data)) {
        return acc.slice(0, -1).concat([Object.assign({}, lastFragment, {
          text: lastFragment.text + value[index].char
        })]);
      } else {
        return [].concat(_toConsumableArray(acc), [{
          styles: data.styles,
          entity: data.entity,
          offset: index,
          text: value[index].char
        }]);
      }
    }
  }, start).map(function (fragment) {
    return Object.assign({}, fragment, {
      entity: fragment.entity != null ? entityMap[fragment.entity] : null
    });
  });
}

exports.default = createTextFragments;